import PropTypes from 'prop-types'
import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@mui/joy'
import { getTaskReserveUsers } from 'features/projectsSlice'
import { projectService } from 'services/projectsService'
import { getAdminUserAssignedHeaders } from 'utils/headers/getAdminUserAssignedHeaders'
import { handleErrorMessage, standarizeStatus } from 'utils/helpers'
import { STATUS } from 'utils/config'
import usePagination from 'hooks/usePagination'
import DeleteModal from 'components/DeleteModal'
import EnchantedTable from 'components/tables/EnchantedTable'

const ReserveUsersSubView = ({ innerLoading, setInnerLoading, handleAssignProjectTaskUser }) => {
  const dispatch = useDispatch()
  const pagination = usePagination()
  const { projectId, taskId } = useParams()
  const { enqueueSnackbar } = useSnackbar()

  const [removeFromListUserObject, setRemoveFromListUserObject] = useState(false)

  const { currentTask, currentTaskReserveUsers } = useSelector((s) => s.projects)

  const handleAction = (action, successMessage, callback) => {
    setInnerLoading(true)
    action
      .then((res) => {
        console.log(res)
        enqueueSnackbar(successMessage, { variant: 'success' })
        callback()
      })
      .catch((err) => {
        console.log(err)
        enqueueSnackbar(handleErrorMessage(err, 'Coś poszło nie tak.'), { variant: 'error' })
      })
      .finally(() => setInnerLoading(false))
  }

  const handleRemoveUserFromReserve = (userId) => {
    handleAction(
      projectService.adminRemoveProjectTaskReserveUser(projectId, taskId, userId),
      'Użytkownik został usunięty z lity.',
      () => {
        setRemoveFromListUserObject(false)
        dispatch(getTaskReserveUsers({ projectId, taskId }))
      }
    )
  }

  if (!currentTaskReserveUsers || !projectId || !taskId) return null

  return (
    <>
      <DeleteModal
        open={removeFromListUserObject}
        handleDelete={() => handleRemoveUserFromReserve(removeFromListUserObject.userId)}
        loading={innerLoading}
        setObject={setRemoveFromListUserObject}
      >
        Czy jesteś pewny, ze chcesz usunąć z listy rezerwowej:{' '}
        <Typography color="primary" fontWeight={500}>
          {removeFromListUserObject.firstName} {removeFromListUserObject.lastName}
        </Typography>
      </DeleteModal>
      <Typography color="primary" fontWeight={500} sx={{ mt: 2 }}>
        Lista rezerwowa:
      </Typography>
      <EnchantedTable
        headers={getAdminUserAssignedHeaders()}
        data={currentTaskReserveUsers}
        offset={(pagination.values.currentPage - 1) * pagination.values.perPage}
        noDataText="Brak listy rezerwowej."
        buttonActions={[
          {
            label: 'Przypisz do zadania',
            color: 'primary',
            func: (el) => handleAssignProjectTaskUser(el.userId),
            loading: innerLoading,
            display: () => standarizeStatus(currentTask.status) !== STATUS.done.value,
          },
          {
            label: 'Usuń z listy',
            color: 'danger',
            func: (user) => setRemoveFromListUserObject(user),
            loading: innerLoading,
          },
        ]}
      />
    </>
  )
}

export default ReserveUsersSubView

ReserveUsersSubView.propTypes = {
  setInnerLoading: PropTypes.func.isRequired,
  innerLoading: PropTypes.bool,
  handleAssignProjectTaskUser: PropTypes.func.isRequired,
}
